import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Goal: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M12 13V2l8 4-8 4' }],
    ['path', { d: 'M20.55 10.23A9 9 0 1 1 8 4.94' }],
    ['path', { d: 'M8 10a5 5 0 1 0 8.9 2.02' }],
  ],
];

export default Goal;
